import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Array, categories: Array, name: String }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const options = {
      chart: {
        type: 'line',
        toolbar: { show: false },
        height: '100%',
        parentHeightOffset: 0,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        },
        selection: {
          enabled: false  // Disable zoom by selection
        },
        zoom: {
          enabled: false  // Disable all zoom functionality
        }
      },
      colors: ['#3b82f6'],
      series: this.dataValue,
      xaxis: {
        categories: this.categoriesValue,
        tickAmount: 5,  // Force exactly 5-6 ticks
        labels: {
          rotate: -45,
          rotateAlways: false,
          maxHeight: 80,
          style: {
            fontSize: '10px',
            colors: '#6b7280'
          },
          showDuplicates: false,
          hideOverlappingLabels: true
        }
      },
      yaxis: {
        title: {
          text: 'NPS Score',
          style: {
            fontSize: '12px',
            fontWeight: 600,
            color: '#6b7280'
          }
        },
        labels: {
          formatter: function(value) {
            return (value >= 0 ? '+' : '') + value.toFixed(0)
          },
          style: {
            fontSize: '11px',
            colors: '#6b7280'
          }
        },
        min: -100,
        max: 100
      },
      stroke: {
        curve: 'smooth',
        width: 3
      },
      markers: {
        size: 5,
        strokeWidth: 2,
        strokeColors: '#fff',
        hover: {
          size: 7
        }
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        borderColor: '#e5e7eb',
        strokeDashArray: 4,
        xaxis: {
          lines: {
            show: false
          }
        }
      },
      tooltip: {
        enabled: true,
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const value = series[seriesIndex][dataPointIndex]
          const date = w.globals.labels[dataPointIndex]

          return `
            <div class="apex-tooltip-custom p-3 bg-white border border-gray-200 rounded shadow-lg">
              <div class="font-semibold text-gray-900 mb-2">${date}</div>
              <div class="text-sm">
                <div class="mb-1">
                  <span class="font-medium">NPS Acumulado:</span>
                  <span class="font-bold ${value >= 50 ? 'text-green-600' : value >= 0 ? 'text-yellow-600' : 'text-red-600'}">
                    ${value >= 0 ? '+' : ''}${value.toFixed(1)}
                  </span>
                </div>
                <div class="text-xs text-gray-500 mt-2 pt-2 border-t border-gray-100">
                  <div>Cálculo: (Promotores - Detratores) / Total × 100</div>
                  <div class="mt-1 italic">Considera todas as respostas até esta data</div>
                </div>
              </div>
            </div>
          `
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
